<ng-container *ngIf="newThemeActive$ | async; else oldAppApprovals">
    <div *ngIf="(approvals$ | async).length else empty" class="p-4">
        <app-approvals [approvals]="(approvals$ | async)"></app-approvals>
    </div>
</ng-container>
<ng-template #oldAppApprovals>
    <ng-container *ngIf="approvals && approvals.length else empty" #oldAppApprovals>
        <div *ngFor="let offer of approvals; let index = index;" class="mb-2 first:pt-5">
            <div [ngSwitch]="offer.calculationType | lowercase">
                <app-loc-term-approval-old *ngSwitchCase="'loc'" [initializeExpanded]="approvals && approvals.length === 1"
                    [offer]="offer">
                </app-loc-term-approval-old>
                <app-loc-term-approval-old *ngSwitchCase="'term'" [initializeExpanded]="approvals && approvals.length === 1"
                    [offer]="offer">
                </app-loc-term-approval-old>
                <app-old-approval *ngSwitchDefault [readOnly]="readOnly"
                    [initializeExpanded]="approvals && approvals.length === 1"
                    [disabled]="offer.calculationType === 'custom' && customControlsDisabled"
                    [channel]="getCalcChannel(offer.id)" [offer]="offer" [loading]="getLoading(offer.id)"
                    [errored]="getErrored(offer.id)" (error)="setErrored($event)"
                    (approvalAdjusted)="handleAdjustedApproval($event)"
                    (pusherPayloadReceived)="handlePusherPayloadReceived($event)">
                </app-old-approval>
            </div>
        </div>
    </ng-container>
</ng-template>
<ng-template #empty>
    <p class="no-offers pt-10">No Approvals Yet</p>
</ng-template>

<ng-template #loading>
    <app-dot-loader-scale></app-dot-loader-scale>
</ng-template>
